import { Link, LinkProps } from 'react-router'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

export default function LinkChip (props: LinkProps) {
  const { children, className } = props

  return (
    <Link className={cn(styles.root, className)} {...props}>
      {children}
    </Link>
  )
}
